import { cn } from "../utils/cn";

// ── Types ─────────────────────────────────────────────────────────────────────

export interface FormSectionProps {
  title: string;
  description?: string;
  /** Number of columns in the fields grid (default 1) */
  columns?: 1 | 2;
  /** Whether to show the divider line below the header (default true) */
  divider?: boolean;
  children: React.ReactNode;
  className?: string;
}

// ── Component ─────────────────────────────────────────────────────────────────

export function FormSection({
  title,
  description,
  columns = 1,
  divider = true,
  children,
  className,
}: FormSectionProps) {
  return (
    <section className={cn("flex flex-col gap-5", className)}>
      {/* Header */}
      <div>
        <h3 className="text-base font-semibold text-content-primary">{title}</h3>
        {description && (
          <p className="mt-0.5 text-sm text-content-secondary">{description}</p>
        )}
        {divider && (
          <div className="mt-3 border-t border-border-default dark:border-border-strong" />
        )}
      </div>

      {/* Fields grid */}
      <div
        className={cn(
          "grid gap-4",
          columns === 2 ? "sm:grid-cols-2" : "grid-cols-1",
        )}
      >
        {children}
      </div>
    </section>
  );
}

FormSection.displayName = "FormSection";
